<script>
import HeaderMixin from "../header-mixin";

export default {
    data() {
        return {
            isActiveLangSwitchDropdown: false
        };
    },

    mixins: [HeaderMixin]
};
</script>
